import { render, staticRenderFns } from "./my-kucun.vue?vue&type=template&id=fa2f3720&scoped=true&"
import script from "./my-kucun.vue?vue&type=script&lang=js&"
export * from "./my-kucun.vue?vue&type=script&lang=js&"
import style0 from "./my-kucun.vue?vue&type=style&index=0&id=fa2f3720&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2f3720",
  null
  
)

export default component.exports